import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import SinglePortfolio from './pages/SinglePortfolio';
import NotFound from './pages/NotFound';

function App() {
  // Initialize dark mode from localStorage or default to light mode
  const [lightMode, setLightMode] = React.useState(() => {
    const savedMode = localStorage.getItem('lightMode');
    return savedMode !== null ? JSON.parse(savedMode) : true;
  });

  // Persist dark mode preference to localStorage
  useEffect(() => {
    localStorage.setItem('lightMode', JSON.stringify(lightMode));
  }, [lightMode]);

  const switchMode = () => {
    setLightMode(!lightMode);
  };

  return (
    <div className={lightMode ? "" : "dark-mode-toggle"}>
      <Routes>
        <Route path="/" element={<Home switchMode={switchMode} lightMode={lightMode} />} />
        <Route path="/portfolio/:work" element={<SinglePortfolio switchMode={switchMode} lightMode={lightMode} />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </div>
  );
}

export default App;
